import axios from '../../service/index'
import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { Button, Divider,  message, Form, Input, Upload, DatePicker, InputNumber, Select } from 'antd'
import E from 'wangeditor'
import moment from 'moment'
const qiniuUpUrl = 'https://up-z1.qiniup.com'
// import './addCourse.less'
const { TextArea } = Input
const FormItem = Form.Item
const { Option } = Select;
class addCourse extends Component {
	constructor(props) {
		super(props)
		this.state = {
			visible: false,
			bosObj: null,
			fileType: 'limit',
			scriptStatus: 'no',
			fileList: [],
			token: '',
			autoCompleteResult: [],
			modelTitle: '新增直播',
			qsCodeName: '',
			introduction: '',
			selectValue: undefined,
			name: '',
			subjectIcon: {},
			premiereTime: undefined,
			lowerTime: undefined,
			preset: '',
			liveUrl: '',
			// subjectId: undefined,
			liveId: '',
			searchName: '',
			dataSource: [],
			qiuniuUrl: '',
			optionList: [],
			poster: {},
			url: '',
			editor: '',
			editorHtml: '',
			editorText: '',
			liveDetail: {},
			disabled: false
		}
	}

	componentDidMount() {
		this.getSubject()
		this.getToken()
		
		let editor = new E(ReactDOM.findDOMNode(this._div))
		this.setState({ editor: editor })
		editor.config.menus = [
			'head',
			'bold',
			'fontSize',
			'fontName',
			'italic',
			'underline',
			'strikeThrough',
			'indent',
			'lineHeight',
			'foreColor',
			'backColor',
			'link',
			'list',
			'todo',
			'justify',
			'quote',
			'table',
			'splitLine',
			'undo',
			'redo',
			'image',
		]
		editor.config.uploadImgMaxLength = 5;
		editor.config.showLinkImg = false;
		editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
		editor.config.withCredentials = false;
		editor.config.uploadImgTimeout = 5 * 1000;
		// editor.customConfig.zIndex = 100;
		let _this = this
		editor.config.customUploadImg = function (resultFiles, insertImgFn) {
			let imgUrl = ''
			let data = new FormData();
			data.append("token", _this.state.token);
			data.append("file", resultFiles[0]);
			axios({
				method: "POST",
				url: qiniuUpUrl,
				data: data,
				onUploadProgress: function (progressEvent) {
					//    var percentCompleted = Math.round(
					// 	   (progressEvent.loaded * 100) /
					// 	   progressEvent.total
					//    );
				},
			}).then((res) => {
				imgUrl = _this.state.url + '/' + res.data.key
				insertImgFn(imgUrl);
			});
		};
		editor.config.onchange = (html) => {
			this.setState({
				editorHtml: html,
				editorText: editor.txt.text()
			})
			//将html值设为form表单的desc属性值
			this.props.form.setFieldsValue({
				'introduce': html
			});
		}
		editor.create()
		this.getDetail()
	}
	getQiniuUrl = v => {
		this.setState({
			qiuniuUrl: v
		})
	}
	validateEditorFrom = (rule, value, callback) => {
		// console.log(this.state.editorText)
		if (this.state.editorHtml.trim() === '') {
			callback('直播详情不能为空');
		}
		callback();
	}
	getSubject() {
		axios.post('subjectController/getSubject', {
			pageSize: 100,
			pageNum: 1,
		}).then(res => {
			if (res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					optionList: arr.list
				})
			}
		})
	}
	getDetail() {
		let id = sessionStorage.getItem('liveDetailId')
		if(id) {
			this.setState({
				modelTitle: '编辑直播'
			})
			axios.get(`liveController/selectById/${id}`).then( res => {
				if(res.data.code === '200') {
					this.setState({
						liveDetail: res.data.data,
						modelTitle: '编辑直播',
						premiereTime: moment(res.data.data.premiereTime),
						lowerTime: moment(res.data.data.lowerTime),
						subjectIcon: {
							type: null,
							uid: null,
							url: res.data.data.picUrl,
							name: res.data.data.name
						},
						fileList: [{ url: res.data.data.picUrl, uid: 'FirjdGoj0FyX6rVCgEPzouRC78dJ', type: 'image/*', name: res.data.data.name }]
					})
					this.state.editor.txt.html(res.data.data.content)
					this.props.form.setFieldsValue({
						'picUrl': this.state.fileList,
					})
				}
			})
		}else {
			this.setState({
				modelTitle: '新增直播'
			})
		}
	}
	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			// let url = Array.isArray(values.picUrl) ? 
			// console.log(values.premiereTime.format('YYYY-MM-DD HH:mm:ss'),)
			// this.setState({ visible: false })
			if (!err) {
				if (new Date(values.premiereTime).getTime() >= new Date(values.lowerTime).getTime()) {
					return message.error('下播时间不能小于开播时间')
				}
				if (this.state.modelTitle === '编辑直播') {
					let pic = values.picUrl[0].url && values.picUrl[0].url ? values.picUrl[0].url : this.state.url + '/' + values.picUrl[0].response.key
					axios.post('liveController/updateLive', {
						id: sessionStorage.getItem('liveDetailId'),
						name: values.name,
						picUrl: pic,
						premiereTime: values.premiereTime.format('YYYY-MM-DD HH:mm:ss'),
						lowerTime: values.lowerTime.format('YYYY-MM-DD HH:mm:ss'),
						preset: values.preset,
						liveUrl: values.liveUrl,
						subjectId: values.subjectId,
						content: values.introduce,
						appid: values.appid
					}).then(res => {
						console.log(res)
						if (res.data.code === '200') {
							message.success('修改成功')
							this.props.history.go(-1)
							
						} else {
							message.error(res.data.msg)
						}
					})
				} else if (this.state.modelTitle === '新增直播') {
					axios.post('liveController/addLive', {
						name: values.name,
						picUrl: this.state.url + '/' + values.picUrl[0].response.key,
						premiereTime: values.premiereTime.format('YYYY-MM-DD HH:mm:ss'),
						lowerTime: values.lowerTime.format('YYYY-MM-DD HH:mm:ss'),
						preset: values.preset,
						liveUrl: values.liveUrl,
						subjectId: values.subjectId,
						content: values.introduce,
						appid: values.appid
					}).then(res => {
						console.log(res)
						if (res.data.code === '200') {
							message.success('新增成功')
							this.setState({
								name: ''
							})
							this.props.history.go(-1)
						} else {
							message.error(res.data.msg)
						}
					})
				}

			}
		});
	}
	downValidateForm = (rule, value, callback) => {
		console.log(new Date().getTime(), new Date(value).getTime())
		if(value&&new Date(value).getTime()<=new Date().getTime()){
			callback('下播时间必须大于现在的时间')
		}else{
			callback()
		}
	}
	getToken = () => {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	normFile = e => {
		if (e.fileList.length === 2) {
			e.fileList = e.fileList.slice(-1);
			message.warning("只能上传一个文件")
		};
		if (Array.isArray(e)) {
			
			return e;
		}
		return e && e.fileList;
	};
	handlePreview = async file => {
		this.setState({
			previewVisible: true,
		});
	}
	handleChangefile = ({ file, fileList }) => {
		if (file.percent === 100) {
			if (file.status === 'done') {
				let fileL = {
					uid: fileList[0].uid,
					name: fileList[0].name,
					status: fileList[0].status,
					url: this.state.url + '/' + fileList[0].response.hash,
					type: fileList[0].type
				}
				this.setState({ fileList: fileL });

			}
		}
		else if (file.status === 'removed') {
			this.setState({ fileList: [] });
		}
	};
	render() {
		const { modelTitle,   premiereTime, lowerTime,  liveDetail } = this.state;
		const { getFieldDecorator } = this.props.form
		const config = {
			rules: [{ type: 'object', required: true, message: '请选择开播时间' }],
			initialValue: modelTitle === '编辑直播' ? premiereTime : undefined,
		};
		const config1 = {
			rules: [{ type: 'object', required: true, message: '请选择下播时间' }],
			initialValue: modelTitle === '编辑直播' ? lowerTime : undefined,
		};
		const uploadButton = (
			<div>
				<Button>上传封面</Button>
				<p style={{ fontSize: '12px', color: '#99999', marginTop: '12px' }}>仅支持jpg/png/jpeg文件，且不超过2M,建议尺寸：750*335px</p>
			</div>
		);
		return (
			<div className="addCourse">
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>{modelTitle}</span>
					<span className="my-button-txt" onClick={() => {
						this.props.history.push('/liveController')
					}}>返回上一级</span>
				</div>
				<Divider />
				<Form labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} onSubmit={this.handleSubmit}>
					<Form.Item label="所属学科">
						{getFieldDecorator('subjectId', {
							initialValue: modelTitle === '编辑直播' ? liveDetail.subjectId : undefined
						})(
							<Select
								placeholder="请选择学科"
							>
								{this.state.optionList.map(item => {
									return (<Option key={item.id} value={item.id}>{item.name}</Option>)
								})}
							</Select>
						)}
					</Form.Item>
					<FormItem label={"直播名称"}>
						{getFieldDecorator('name', {
							initialValue: modelTitle === '编辑直播' ? liveDetail.name : '',
							rules: [{ required: true, message: '请输入直播名称!' }, { max: 20, message: '最多输入20个字符' }],
						})(
							<Input placeholder='请输入直播名称' />
						)}
					</FormItem>
					{/* <Form.Item label="封面图">
						{getFieldDecorator('picUrl', {
							initialValue: modelTitle === '编辑直播' ? subjectIcon : '',

							rules: [{ type: 'object', required: true, message: '请上传封面!' }],
						})(
							<UploadQiniu getQiniuUrl={this.getQiniuUrl}/>
						)}
					</Form.Item> */}
					<Form.Item label="直播封面">
						{getFieldDecorator('picUrl', {
							rules: [{ required: true, message: '请上传直播封面!', }],
							valuePropName: 'fileList',
							getValueFromEvent: this.normFile,
						})(
							<Upload
								accept=".png,.jpg"
								action={qiniuUpUrl}
								listType='picture'
								disabled={this.state.disabled}
								beforeUpload={(file, fileList) => {
									const isLt10M = file.size / 1024 / 1024 <= 2;
									if (!isLt10M) {
										message.error("文件大小限制在2M以下！");
										return false;
									}
								}}
								onChange={this.handleChangefile}
								data={{ token: this.state.token }}>
									{uploadButton}
								{/* {this.state.fileList.length >= 1 ? '' : uploadButton} */}
							</Upload>
						)}
					</Form.Item>
					<Form.Item label="开播时间">
						{getFieldDecorator('premiereTime',
							config,
							{
								rules: [{ required: true, message: '请选择开播时间!' }],
							})(
								<DatePicker showTime format="YYYY-MM-DD HH:mm:ss" />,
							)}
					</Form.Item>
					<Form.Item label="下播时间">
						{getFieldDecorator('lowerTime',
						config1,
							{
								rules: [
									{ required: true, message: '请选择下播时间' },
									{ validator: this.downValidateForm }
								]
							})(
								<DatePicker showTime disabledDate={this.disabledDate} format="YYYY-MM-DD HH:mm:ss" />,
							)}
					</Form.Item>
					<FormItem label={"预设人数"}>
						{getFieldDecorator('preset', {
							initialValue: modelTitle === '编辑直播' ? liveDetail.preset : '',

						})(
							<InputNumber placeholder='请输入预设人数' precision={0} />
						)}
					</FormItem>
					<FormItem label={"AppID"}>
						{getFieldDecorator('appid', {
							initialValue: modelTitle === '编辑直播' ? liveDetail.appid : '',

						})(
							<Input placeholder='请输入AppID'  />
						)}
					</FormItem>
					<FormItem label={"直播链接"}>
						{getFieldDecorator('liveUrl', {
							initialValue: modelTitle === '编辑直播' ? liveDetail.liveUrl : ''
						})(
							<TextArea style={{ width: '100%' }} placeholder='请输入直播链接' />
						)}
					</FormItem>
					<FormItem label={"直播详情"} style={{zIndex: 1}}>
						{getFieldDecorator('introduce', {
							rules: [{ required: true, }, { validator: this.validateEditorFrom }],
							initialValue:  modelTitle === '编辑直播' ? liveDetail.content : ''
						})(
							<div  ref={(ref) => this._div = ref}></div>

						)}
					</FormItem>
					<FormItem >
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<Button type="primary" style={{ marginRight: '30px' }} onClick={() => {
								this.props.history.push('/liveController')
							}}>取消</Button>
							<Button type="primary" htmlType="submit">确定</Button>
						</div>
					</FormItem>
				</Form>

			</div>
		)
	}
}

export default Form.create({ name: 'validate_other' })(addCourse)
